import type { FC } from 'react';
import React from 'react';

import Tooltip from '@atlaskit/tooltip/Tooltip';

import { TimeAgo } from '@confluence/time-ago';

type Props = {
	actionTime: string;
};

export const ActionTime: FC<Props> = ({ actionTime }) => {
	return (
		<Tooltip content={new Date(actionTime).toLocaleString()} tag="span">
			<TimeAgo date={actionTime} />
		</Tooltip>
	);
};
